import React, { useState, useEffect } from 'react';
import API from '../../services/api'; // Aapka exact API import

const DocumentReportsPage = () => {
    const [reports, setReports] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 15;

    useEffect(() => {
        fetchReports(currentPage, statusFilter, searchTerm);
    }, [currentPage, statusFilter]);

    const fetchReports = async (page, status, search) => {
        try {
            let url = `/documents/reports?page=${page}&limit=${limit}`;
            if (status) url += `&status=${status}`;
            if (search) url += `&search=${search}`;

            const res = await API.get(url);
            if (res.data.success) {
                setReports(res.data.data);
                setTotalPages(res.data.totalPages);
            }
        } catch (err) {
            console.error("Error fetching reports:", err);
        }
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchReports(1, statusFilter, searchTerm);
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3>📊 Detailed Document Reports & History</h3>
                <div>
                    <button onClick={() => { setStatusFilter(''); setCurrentPage(1); }} style={tabBtn(statusFilter === '')}>All</button>
                    <button onClick={() => { setStatusFilter('Pending'); setCurrentPage(1); }} style={tabBtn(statusFilter === 'Pending')}>Pending</button>
                    <button onClick={() => { setStatusFilter('Available'); setCurrentPage(1); }} style={tabBtn(statusFilter === 'Available')}>Available</button>
                    <button onClick={() => { setStatusFilter('Issued'); setCurrentPage(1); }} style={tabBtn(statusFilter === 'Issued')}>Issued</button>
                </div>
            </div>

            <form onSubmit={handleSearchSubmit} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <input 
                    type="text" 
                    placeholder="Search by Engine No, Chassis No, or Lot ID..." 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={inputStyle}
                />
                <button type="submit" style={btnPrimary}>Search</button>
            </form>

            <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                <table style={tableStyle}>
                    <thead>
                        <tr style={{ background: '#f1f5f9' }}>
                            <th style={thTd}>Stock ID</th>
                            <th style={thTd}>Lot ID</th>
                            <th style={thTd}>Model</th>
                            <th style={thTd}>Engine No</th>
                            <th style={thTd}>Chassis No</th>
                            <th style={thTd}>Status</th>
                            <th style={thTd}>Doc Type</th>
                            <th style={thTd}>Location</th>
                            <th style={thTd}>Received / Issued Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reports.length > 0 ? reports.map(r => (
                            <tr key={r.inventory_stock_id}>
                                <td style={thTd}>{r.inventory_stock_id}</td>
                                <td style={thTd}>{r.lot_id || 'N/A'}</td>
                                <td style={thTd}>{r.model_name}</td>
                                <td style={thTd}>{r.engine_number}</td>
                                <td style={thTd}>{r.chassis_number}</td>
                                <td style={thTd}><span style={badgeStyle(r.doc_status)}>{r.doc_status}</span></td>
                                <td style={thTd}>{r.document_type || '-'}</td>
                                <td style={thTd}>{r.physical_location || '-'}</td>
                                <td style={thTd}>
                                    {r.doc_status === 'Issued' 
                                        ? `Issued to: ${r.issued_to} (${r.issuance_time?.substring(0,10)})` 
                                        : (r.received_by ? `Rec by: ${r.received_by} (${r.received_date?.substring(0,10)})` : '-')}
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>No records found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
                <button 
                    disabled={currentPage === 1} 
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    style={{ ...paginationBtn, opacity: currentPage === 1 ? 0.5 : 1 }}
                >
                    ◀ Previous
                </button>
                <span>Page <b>{currentPage}</b> of <b>{totalPages || 1}</b></span>
                <button 
                    disabled={currentPage >= totalPages} 
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    style={{ ...paginationBtn, opacity: currentPage >= totalPages ? 0.5 : 1 }}
                >
                    Next ▶
                </button>
            </div>
        </div>
    );
};

// Styles
const inputStyle = { flex: 1, padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' };
const btnPrimary = { background: '#0284c7', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' };
const thTd = { padding: '12px', borderBottom: '1px solid #e2e8f0' };
const tabBtn = (isActive) => ({ padding: '8px 14px', marginRight: '5px', background: isActive ? '#0284c7' : '#e2e8f0', color: isActive ? '#fff' : '#000', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' });
const paginationBtn = { background: '#334155', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' };
const badgeStyle = (status) => ({
    padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold',
    background: status === 'Available' ? '#dcfce7' : (status === 'Issued' ? '#fef3c7' : '#fee2e2'),
    color: status === 'Available' ? '#166534' : (status === 'Issued' ? '#92400e' : '#991b1b')
});

export default DocumentReportsPage;